import styled from 'styled-components';

export const Button = styled.button`
  background: none;
  border: none;
  height: 17px;
  min-width: 17px;
  padding: 0;
  width: 17px;
`;

export const IdentifierText = styled.div`
  color: ${({ theme }) => theme.typography.color.primary};
  margin-bottom: ${({ theme }) => theme.spacing.base.xs};
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
